<template>
  <Modal v-model="showModal"
    class="sms-verify-modal"
    scrollable
    :mask="true"
    :mask-closable="false"
    @on-cancel="closeModal"
    title="身份验证">
    <Form ref="verifySmsForm"
      label-position="left"
      :model="verifySmsModel"
      :label-width="120">
      <FormItem label="手机号码" prop="mobile" :rules="[{required:true,validator:validatePhone,trigger:'blur'}]">
        <template v-if="mobileDisplay">
          <span>{{mobileDisplay}}</span>
          <Button type="primary" style="margin-left:5px" @click="sendSms" :disabled="smsCD">{{smsCD?`${smsCountDown}秒后重发`:'发送验证码'}}</Button>
          <div class="text-grey small" v-if="smsCD">验证码已发送至{{mobileDisplay}},请注意查收</div>
        </template>
        <template v-else>
          <span>没有绑定手机号码</span>
          <Button type="primary" style="margin-left:5px" @click="goBindMobile">去绑定</Button>
        </template>
      </FormItem>
      <FormItem label="短信验证码" prop="code" :rules="[{required:true,message:'请输入短信验证码',trigger:'blur'}]">
        <Input v-model="verifySmsModel.code" style="width:100px" placeholder="短信验证码" />
      </FormItem>
    </Form>
    <div slot="footer">
      <Button type="primary" @click="submit">验证</Button>
      <Button @click="closeModal">取消</Button>
    </div>
  </Modal>
</template>

<script>
import Api from './../../api/Api'
export default {
  name: 'SmsVerify',
  props: {
    show: Boolean,
    mobile: String
  },
  data () {
    return {
      showModal: false,
      verifySmsModel: {
        mobile: null,
        code: null
      },
      smsCD: false,
      smsCountDown: 60,
      smsCountDownTask: null
    }
  },
  watch: {
    show: function (newVal) {
      if (newVal) {
        this.showVerifyModal()
      } else {
        // this.closeModal()
      }
    }
  },
  computed: {
    mobileDisplay () {
      let mobile = this.mobile
      if (mobile && mobile.length >= 11) {
        let last4Digits = mobile.substr(mobile.length - 4)
        let prefixDigits = mobile.substr(0, mobile.length - 4 - 4)
        return prefixDigits + '****' + last4Digits
      }
      return null
    }
  },
  mounted () {
    if (this.show) {
      this.showVerifyModal()
    } else {
      // this.closeModal()
    }
  },
  methods: {
    goBindMobile () {
      this.closeModal('bindMobile')
    },
    showVerifyModal () {
      if (this.smsCountDownTask) {
        clearInterval(this.smsCountDownTask)
      }
      this.verifySmsModel = {
        mobile: this.mobile,
        code: null
      }
      this.smsCD = false
      this.smsCountDown = 60
      this.showModal = true
      // console.log('showVerifyModal')
    },
    closeModal (action) {
      if (this.smsCountDownTask) {
        clearInterval(this.smsCountDownTask)
      }
      this.verifySmsModel = {
        mobile: null,
        code: null
      }
      this.showModal = false
      this.$emit('on-cancel', action)
    },
    validatePhone (rule, value, callback) {
      if (!value) {
        return callback(new Error('手机号不能为空'))
      } else if (!/^1[3456789]\d{9}$/.test(value)) {
        callback('手机号格式不正确')
      } else {
        callback()
      }
    },
    sendSms () {
      if (!this.verifySmsModel || !this.verifySmsModel.mobile) {
        this.$Message.error('请填写手机号码')
        return false
      }
      Api.Auth(this).sendVerifySmsCode().then(() => {
        this.$Message.success('短信验证码发送成功')
        if (this.smsCountDownTask) {
          clearInterval(this.smsCountDownTask)
        }
        this.smsCD = true
        this.smsCountDown = 60
        this.smsCountDownTask = setInterval(() => {
          if (this.smsCountDown >= 1) {
            this.smsCountDown--
          } else {
            this.smsCountDown = 60
            this.smsCD = false
            clearInterval(this.smsCountDownTask)
          }
        }, 1000)
      }).catch(err => {
        this.$Message.error('短信验证码发送失败!' + err.message)
      })
    },
    async submit () {
      this.$refs.verifySmsForm.validate(async (valid) => {
        if (valid) {
          this.$emit('on-submit', this.verifySmsModel)
          this.closeModal()
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.sms-verify-modal {
}
</style>
